var exports = {
  "iE": "xaee3c4fa--d664f5--wrapper",
  "Wp": "xaee3c4fa--d664f5--header-wrapper",
  "nf": "xaee3c4fa--d664f5--link",
};

module.exports = exports;
